module.exports = __webpack_public_path__ + "img/Eidlin.180f3204.jpeg";